const ProductListStyle = {
  CARD: 'CARD',
  CARD_LARGE: 'CARD_LARGE'
};

export default ProductListStyle;
